/* tslint:disable */
/* eslint-disable */
import { GlobalEnumsAceSprache as AceXFoundPortalCoreEntitiesGlobalEnumsAceSprache } from '../../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-sprache';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IVerifyRegistrationRequest {
  email?: null | string;
  sprache?: AceXFoundPortalCoreEntitiesGlobalEnumsAceSprache;
}
export class VerifyRegistrationRequest extends BaseModel implements IVerifyRegistrationRequest {
  email?: null | string;
  sprache?: AceXFoundPortalCoreEntitiesGlobalEnumsAceSprache;
}

